import { GLOBAL_SEARCH_RESULTS_SECTIONS } from "@/utils/constant";
import { GlobalSearchSectionsType } from "@/utils/types/algolia";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type TPageFitlerPayload = Partial<
  Record<GlobalSearchSectionsType, { filters: number }>
> | null;
interface AlgoliaState {
  filters: number;
  totalTimeFilter: any;
  algoliaLoading: boolean;
  pageFilters: TPageFitlerPayload;
}

const initialState: AlgoliaState = {
  filters: 0,
  algoliaLoading: true,
  pageFilters: null,
  totalTimeFilter: [],
};

type TPayload = GlobalSearchSectionsType;

const algoliaSlice = createSlice({
  name: "algolia",
  initialState,
  reducers: {
    setFilters(state: AlgoliaState, action: PayloadAction<number>) {
      state.filters = action.payload;
    },
    setClearFilters(state: AlgoliaState) {
      state.filters = 0;
    },
    setAlgoliaLoading(state: AlgoliaState, action: PayloadAction<boolean>) {
      state.algoliaLoading = action.payload;
    },
    setPageFilters(state: AlgoliaState, action: PayloadAction<TPayload>) {
      const type = action.payload;
      const filterObject = {
        [type]: { filters: (state.pageFilters?.[type]?.filters ?? 0) + 1 },
      };
      state.pageFilters = { ...state.pageFilters, ...filterObject };
    },
    clearPageFilters(state: AlgoliaState, action: PayloadAction<TPayload>) {
      const type = action.payload;
      const filterObject = { [type]: null };
      state.pageFilters = { ...state.pageFilters, ...filterObject };
    },
    setTotalTimeFilter(state: AlgoliaState, action: PayloadAction<any>){
      state.totalTimeFilter = action.payload;
    }
  },
});

export const {
  setFilters,
  setClearFilters,
  setAlgoliaLoading,
  setPageFilters,
  clearPageFilters,
  setTotalTimeFilter,
} = algoliaSlice.actions;

export default algoliaSlice.reducer;
